// Versions of the Terms of Service and Privacy Policy that users accept. The frontend sends the
// versions it was built with and the backend checks them. A bump only affects users who have
// not accepted yet; what should happen to users who accepted an older version is not decided.
export const CURRENT_TERMS_VERSION = '2024-09-25';
export const CURRENT_PRIVACY_VERSION = '2024-09-25';
